export default __webpack_public_path__ + "static/backgroundHome--blurH-42175c5c17c44f2a7f3c14fbab81683e.jpg";